module.exports = __webpack_public_path__ + "static/media/banner_bg.a4bb8c56.png";